import { render } from "./KategorieBearbeitenView.vue?vue&type=template&id=3a3fb7ba&scoped=true"
import script from "./KategorieBearbeitenView.vue?vue&type=script&lang=js"
export * from "./KategorieBearbeitenView.vue?vue&type=script&lang=js"

import "./KategorieBearbeitenView.vue?vue&type=style&index=0&id=3a3fb7ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3fb7ba"]])

export default __exports__